// Using the primitives Tag component for consistent styling
import { Tag, TextBold, useDynamicStyles } from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, View } from 'react-native';

// Extended tag type to include the name property required for display
type TagWithName = {
  id?: string;
  name: string;
  session_id: string;
  tag_id: string;
};

type Props = {
  categoryName?: string;
  tags?: TagWithName[];
  onTagPress: (id?: string) => void;
  showTagBackground: (id?: string) => boolean;
};

export function TagCategorySection({
  categoryName,
  tags,
  onTagPress,
  showTagBackground,
}: Props) {
  const styles = useDynamicStyles(createStyles);

  if (!tags || tags.length === 0) return null;

  return (
    <View style={styles.categoryAndTagContainer}>
      <TextBold style={styles.categoryTitle}>
        {categoryName ?? 'Other'}
      </TextBold>
      {tags.map((tag) => (
        <Tag
          key={tag.id}
          name={tag.name}
          id={tag.id}
          onPress={onTagPress}
          showBackground={showTagBackground(tag.id)}
          type={categoryName === 'Tracks' ? 'category' : 'tag'}
        />
      ))}
    </View>
  );
}

const createStyles = () =>
  StyleSheet.create({
    categoryAndTagContainer: {
      gap: 8,
      alignItems: 'flex-start',
    },
    categoryTitle: {
      fontSize: 16,
    },
  });
